import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.create";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import Block from '../../../block/Block';
import FootnoteRegion from './FootnoteRegion';
import { renderCmsComponent } from '../../utils';
export var SplashRegions = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(SplashRegions, _React$PureComponent);

  var _super = _createSuper(SplashRegions);

  function SplashRegions() {
    var _this;

    _classCallCheck(this, SplashRegions);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getRegionClassName", function (metakey) {
      var metadata = _this.props.metadata;
      /*eslint-disable*/

      var classCreators = {
        top_region_backgroundcolor: _this.getTopClassName,
        primary_region: _this.getPrimaryClassName,
        body_region: _this.getPrimaryClassName
      };
      /*eslint-enable*/

      var classCreator = classCreators[metakey];
      return classCreator ? classCreator(metadata[metakey]) : '';
    });

    _defineProperty(_assertThisInitialized(_this), "getTopClassName", function (topMetadata) {
      return topMetadata ? topMetadata['Key'] || topMetadata['key'] : '';
    });

    _defineProperty(_assertThisInitialized(_this), "getPrimaryClassName", function (primaryMetadata) {
      return primaryMetadata && Object.keys(primaryMetadata).reduce(function (className, dataName, i) {
        var data = primaryMetadata[dataName];
        return data ? className + ((i > 0 ? ' ' : '') + (data['Key'] || data['key'])) : className;
      }, '');
    });

    return _this;
  }

  _createClass(SplashRegions, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          regions = _this$props.regions,
          templateType = _this$props.templateType;
      var top = regions.top,
          primary = regions.primary,
          body = regions.body,
          bottom = regions.bottom,
          footnote = regions.footnote; // Manually create array to guarantee the order of the regions

      var regionList = [{
        name: 'top',
        content: top,
        metakey: 'top_region_backgroundcolor'
      }, {
        name: 'primary',
        content: primary,
        metakey: 'primary_region'
      }, {
        name: 'body',
        content: body,
        metakey: 'body_region'
      }, {
        name: 'bottom',
        content: bottom,
        metakey: ''
      }, {
        name: 'footnote',
        content: footnote,
        metakey: ''
      }];
      return regionList.map(function (_ref, rId) {
        var name = _ref.name,
            content = _ref.content,
            metakey = _ref.metakey;
        var regionClass = "splash-region-".concat(name, " ").concat(_this2.getRegionClassName(metakey));
        if (!content || !content.length) return null;
        return name === 'footnote' ? /*#__PURE__*/React.createElement(FootnoteRegion, {
          content: content,
          templateType: templateType,
          key: "".concat(name, "_").concat(rId),
          className: regionClass
        }) : /*#__PURE__*/React.createElement(Block, {
          key: "".concat(name, "_").concat(rId),
          className: "".concat(regionClass, " clearFloat")
        }, content.map(function (component, index) {
          return renderCmsComponent(component, index, content);
        }));
      });
    }
  }]);

  return SplashRegions;
}(React.PureComponent);
SplashRegions.propTypes = {
  regions: PropTypes.object,
  metadata: PropTypes.object
};
export default SplashRegions;